// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
   
    max-width: 700px;
    margin: 40px auto;
    padding: 0px 20px 20px 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .form-title {
    font-size: 22px;
    font-weight: bold;
    color: #222;
    margin-bottom: 20px;
    text-align: start;
  }

  .form-group input{
   max-width: 315px
  }
  
  .form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .form-row {
    display: flex;
    flex-direction: row;
    gap: 15px;
    

  }
  
  .label{
    text-align: start;

  }
  .form-group {
    display: flex;
    flex-direction: column;
  
    flex: 1 1;
  }

  .textarea{
    padding: 10px 14px;
    border: 1px solid #d4d2d2;
    border-radius: 8px;
    font-size: 13px;
    outline: none;
    transition: border-color 0.2s;
  }
  .Toastify__toast-body {
    font-size: 14px; /* Энд хүссэн хэмжээ */
  }

  .textarea:focus {
    border-color: #007bff;
 
  }
  
  .error {
    color: #e53935;
    font-size: 12px;
    margin-top: 4px;
    text-align: start;
  }

  .form-input {
    flex: 1 1;

    padding: 10px 14px;
    border: 1px solid #d4d2d2;
    border-radius: 8px;
    font-size: 13px;
    outline: none;
    transition: border-color 0.2s;
  }
  
  .form-input:focus {
    border-color: #007bff;
 
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
  }
  
  .form-group label {
    font-size: 14px;
    margin-bottom: 6px;
    color: #333;
  }
  
  textarea.form-input {
    resize: vertical;
  }
  
  .submit-btn {
    background: #e53935;
    color: #fff;
    padding: 12px 20px;
    font-size: 15px;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    align-self: flex-start;
    transition: background 0.2s;
  }
  
  .submit-btn:hover {
    background: #c62828;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/style/feedbackForm.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;GACC;EACD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;;EAGX;;EAEA;IACE,iBAAiB;;EAEnB;EACA;IACE,aAAa;IACb,sBAAsB;;IAEtB,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,eAAe,EAAE,sBAAsB;EACzC;;EAEA;IACE,qBAAqB;;EAEvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAO;;IAEP,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;;EAEvB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":[".form-container {\n   \n    max-width: 700px;\n    margin: 40px auto;\n    padding: 0px 20px 20px 20px;\n    background: #fff;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  }\n  \n  .form-title {\n    font-size: 22px;\n    font-weight: bold;\n    color: #222;\n    margin-bottom: 20px;\n    text-align: start;\n  }\n\n  .form-group input{\n   max-width: 315px\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .form-row {\n    display: flex;\n    flex-direction: row;\n    gap: 15px;\n    \n\n  }\n  \n  .label{\n    text-align: start;\n\n  }\n  .form-group {\n    display: flex;\n    flex-direction: column;\n  \n    flex: 1;\n  }\n\n  .textarea{\n    padding: 10px 14px;\n    border: 1px solid #d4d2d2;\n    border-radius: 8px;\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.2s;\n  }\n  .Toastify__toast-body {\n    font-size: 14px; /* Энд хүссэн хэмжээ */\n  }\n\n  .textarea:focus {\n    border-color: #007bff;\n \n  }\n  \n  .error {\n    color: #e53935;\n    font-size: 12px;\n    margin-top: 4px;\n    text-align: start;\n  }\n\n  .form-input {\n    flex: 1;\n\n    padding: 10px 14px;\n    border: 1px solid #d4d2d2;\n    border-radius: 8px;\n    font-size: 13px;\n    outline: none;\n    transition: border-color 0.2s;\n  }\n  \n  .form-input:focus {\n    border-color: #007bff;\n \n  }\n  \n  .form-group {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .form-group label {\n    font-size: 14px;\n    margin-bottom: 6px;\n    color: #333;\n  }\n  \n  textarea.form-input {\n    resize: vertical;\n  }\n  \n  .submit-btn {\n    background: #e53935;\n    color: #fff;\n    padding: 12px 20px;\n    font-size: 15px;\n    font-weight: bold;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    align-self: flex-start;\n    transition: background 0.2s;\n  }\n  \n  .submit-btn:hover {\n    background: #c62828;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
